<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <PrimaryButton
          @click="editItem"
          v-if="params.context.parentComponent.permissions.change"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-pencil"
          iconClass=""
        >
        </PrimaryButton>
      </template>
      <span>Edit</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <ErrorButton
          v-if="params?.context?.parentComponent?.permissions?.delete"
          @click="deleteItem"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-delete"
          iconClass=""
        >
        </ErrorButton>
      </template>
      <span>Delete</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.params.context.parentComponent.editFieldConfiguration(
        this.params.data.id
      );
    },
    deleteItem() {
      this.$root
        .$confirm(
          "Delete?",
          `Are you sure you want to delete ${this.params.data.name} of module ${this.params.data.module}?`,
          { color: "error" }
        )
        .then((confirm) => {
          if (confirm) {
            this.params.context.parentComponent.deleteFieldConfiguration(
              this.params.data.id
            );
          }
        });
    },
  },
};
</script>
